import { createFileRoute } from '@tanstack/react-router'

import DataUsageCalculator from 'pages/DataUsageCalculator'

export const Route = createFileRoute('/_auth/_global/data-usage-calculator')({
  component: DataUsageCalculator,
})
